import { MRT_Cell, MRT_ColumnDef } from "material-react-table";
import { Accessor } from "../../../../utilities/types";
import type { BaseDataModel } from "../../../../models";

interface DateColumnOptions<T extends BaseDataModel> {
	accessorKeyOrFn?: Accessor<Date, T>;
	defaultText?: string;
	isRangeFilter?: boolean;
}

const getDateColumnText = <T extends BaseDataModel>(cell: MRT_Cell<T, unknown>, defaultText: string) => {
	const date = cell.getValue<Date>();
	return !date ? defaultText : date.toLocaleDateString();
};

export const dateColumn = <T extends BaseDataModel>(
	header: string,
	{ accessorKeyOrFn = undefined, defaultText = "-", isRangeFilter = false }: DateColumnOptions<T> = {},
) =>
	({
		id: header.toLowerCase(),

		// @ts-ignore TODO Need to make this a better type based paradigm...
		accessorFn: (row) =>
			typeof accessorKeyOrFn === "function"
				? accessorKeyOrFn(row)
				: accessorKeyOrFn
					? (row[accessorKeyOrFn] as Date | undefined)
					: undefined,

		header,
		size: 100,
		visibleInShowHideMenu: true,
		filterVariant: isRangeFilter ? "date-range" : "date",
		filterFn: isRangeFilter ? "betweenInclusive" : "greaterThanOrEqualTo",
		enableGrouping: true,

		Cell: ({ cell }) => {
			return getDateColumnText<T>(cell, defaultText);
		},

		GroupedCell: ({ cell }) => {
			return getDateColumnText<T>(cell, defaultText);
		},
	}) as MRT_ColumnDef<T>;
